import { defineMessages } from "react-intl";

export const messages = defineMessages({
  manageApp: {
    id: "bfj3NC",
    defaultMessage: "Manage extension",
    description: "Button with Manage app label",
  },
  appSettings: {
    id: "aUUgUV",
    defaultMessage: "Extension settings",
    description: "Button with  app settings label",
  },
});
